
define('core/browserfs',["require", "exports", './buffer', './node_fs', './node_path', './node_process'], function(require, exports, buffer, node_fs, node_path, node_process) {
    function install(obj) {
        obj.Buffer = buffer.Buffer;
        obj.process = node_process.process;
        var oldRequire = obj.require != null ? obj.require : null;

        obj.require = function (arg) {
            var rv = exports.BFSRequire(arg);
            if (rv == null) {
                return oldRequire.apply(null, Array.prototype.slice.call(arguments, 0));
            } else {
                return rv;
            }
        };
    }
    exports.install = install;

    exports.FileSystem = {};
    function registerFileSystem(name, fs) {
        exports.FileSystem[name] = fs;
    }
    exports.registerFileSystem = registerFileSystem;

    function BFSRequire(module) {
        switch (module) {
            case 'fs':
                return node_fs.fs;
            case 'path':
                return node_path.path;
            case 'buffer':
                return buffer;
            case 'process':
                return node_process.process;
            default:
                return exports.FileSystem[module];
        }
    }
    exports.BFSRequire = BFSRequire;

    function initialize(rootfs) {
        return node_fs.fs._initialize(rootfs);
    }
    exports.initialize = initialize;
});
//# sourceMappingURL=browserfs.js.map
;